import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzRadioGroupAccessibilityDirective } from '../../../directives/nz-radio-group-accessibility.directive';

@Component({
    selector: 'app-tipside-modal',
    templateUrl: './tipside-modal.component.html',
    styleUrls: ['./tipside-modal.component.scss'],
    imports: [NzRadioModule, NzRadioGroupAccessibilityDirective, ReactiveFormsModule, NzBadgeModule, CommonModule, TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TipsideModalComponent implements OnInit {
  @Output() modalOneRadioEmitter: EventEmitter<FormControl> = new EventEmitter<FormControl>();
  readonly nzModalData = inject(NZ_MODAL_DATA);
  dataModal?: any;
  choiceSelected: FormControl = new FormControl();
  texts!: [];

  constructor(
    private modalRef: NzModalRef,
    private translateService: TranslateService
  ) {}

  public ngOnInit(): void {
    this.dataModal = this.nzModalData.dataModal;
    this.translateService.onLangChange.subscribe((_: LangChangeEvent): void => {
      this.translateService.get('steps.tipsideWithModal.modalContent.texts').subscribe((res) => (this.texts = res));
    });
    this.translateService.get('steps.tipsideWithModal.modalContent.texts').subscribe((res) => (this.texts = res));
  }

  protected close(): void {
    this.modalRef.close();
  }

  protected save(): void {
    this.modalRef.close(this.choiceSelected);
  }
}
